export default "__VITE_ASSET__DXGYdI6t__"